.pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.1;
  letter-spacing: 0.14px;
  white-space: nowrap;
  border: 1px solid transparent;
}

.review {
  background: var(--yellow-20);
  border-color: var(--yellow-20);
  color: var(--yellow-90);
}

.accountsToConnect {
  background: #ffc800;
  border-color: #ffc800;
  color: var(--dark-90);
}

.approved {
  background: var(--green-10);
  border-color: var(--green-10);
  color: var(--green);
}

.draft {
  background: var(--dark-4);
  border-color: var(--dark-4);
  color: var(--dark-60);
}

.posted {
  background: var(--upgrade-10);
  border-color: var(--upgrade-10);
  color: var(--upgrade);
}

.failed {
  background: var(--red-10);
  border-color: var(--red-10);
  color: var(--red-90);
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  margin-left: 6px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 16px;
}

.badgeError {
  background: var(--red-50);
  color: var(--light-100);
}

.badgeWarning {
  background: #f6ac00;
  color: var(--dark-90);
}
